import { createContext } from 'react'

import { AudioManagerType } from '../hooks/use_audio_manager'

export const AppAudioContext = createContext<AudioManagerType>({})
